import { IVersion, IPlanCollection } from "@stores/vlp"
import { observer, uiConstants, computed, useAsObservableSource, useLocalStore, TimeAgo } from "@api"
import {ISyncProgressStatus, StoresInstance} from '@stores'
import { IFilterGroupItem } from "@api/graphql"
import { useSyncIndicatorStore, StopSyncButton } from "."
import * as css from './HeaderSyncIndicator.css'
import { Checkbox, Icon, Button } from "@blueprintjs/core"
import React, { useEffect, useState } from "react"
import { CircularProgress, Popover } from "@material-ui/core"
import { CheckboxInput } from "centric-ui-components"
import { VipLocalStore, useVipLocalStore } from '@modules'
import { Tooltip2 } from "@api"

interface ISyncIndicatorCollectionVersionProps {
    version?: IVersion,
    collection: IPlanCollection
    isEmptySelection: boolean
  }
  
export class SyncIndicatorCollectionVersionStore extends VipLocalStore {
    constructor(stores: StoresInstance, public props?: ISyncIndicatorCollectionVersionProps) {
      super(stores)
      const {syncProgress} = this
      if(this.props?.isEmptySelection && false){
        if (!syncProgress.byId.has(this.props.collection?.id)) {
          syncProgress.byId.set(
            this.props.collection?.id,
            { })
        }
      }
    }
  
    get id() {
      return this.props.version?.id ?
        this.props.collection?.id + uiConstants.SEPARATOR + this.props.version?.id :
        this.props.collection?.id
    }
  
    @computed get status(): ISyncProgressStatus {
      const {syncProgress: {byId}} = this,
        {id} = this
      return byId.get(id)
    }
  
    @computed get percentage(): number {
      return this.status?.percent ?? 0
    }
  
    @computed get versionSyncInProgress(): boolean {
      return this.percentage > 0 && this.percentage < 100 ? true : false
    }
  
    @computed get itemCount(): number {
      const {store} = this.filter.seasonSelectorFilters[0]
      const entry:IFilterGroupItem = _.head(store?.data?.entries?.filter((e:IFilterGroupItem)=> e?.exId === this.props.version?.id))
      return entry?.count
    }
  }
  
export const SyncIndicatorCollectionVersion = observer<ISyncIndicatorCollectionVersionProps>(function SyncIndicatorCollectionVersion({collection, version}) {
    const {onClickCollectionVersion, selectedCollectionVersion, isEmptyCollectionVersionSelection, inProgress, idLastSync} = useSyncIndicatorStore(),
      obsProps = useAsObservableSource({collection, version, isEmptySelection:isEmptyCollectionVersionSelection()}),
      {strings, vlp: {hierarchy: {collectionVersionCountMap, fetchCollectionVersionCount}}, percentage, itemCount, versionSyncInProgress, id} = useVipLocalStore((workspaceStores) => new SyncIndicatorCollectionVersionStore(workspaceStores, obsProps)),
      checked = selectedCollectionVersion.has(collection.id) && _.findIndex(selectedCollectionVersion.get(collection.id), function(v) { return v.id == version.id }) > -1,
    {syncIndicator: {lastSync: lastSyncString, empty, never}} = strings

    useEffect(() => {
      fetchCollectionVersionCount()
    }, [versionSyncInProgress])

    const [showLastSync, setLastSync] = useState(false)
    const lastSyncJSX:any = idLastSync.has(id) && idLastSync.get(id) ? [lastSyncString, ': ', <TimeAgo key="last-sync" date={idLastSync.get(id)}/>]: lastSyncString+': '+never
    return <div key={version.id} className={css.versionchkbox} onMouseOver={()=> setLastSync(true)}>
            <Tooltip2 content={lastSyncJSX}>
              <CheckboxInput
                        key={id}
                        disabled={inProgress}
                        className={css.checkbox}
                        label={version.name}
                        checked={checked}
                        onChange={() => onClickCollectionVersion(collection.id, version)}
                      />
            </Tooltip2>
            <div className={css.countLabel}>({collectionVersionCountMap.get(id)??0})</div>
            {checked && percentage >= 100 ? <Icon className={css.progressCircleVersion} icon="tick-circle"/>: checked && percentage > 0 ? <CircularProgress className={css.progressCircleVersion} size={20} variant={percentage <=10 ? "indeterminate":"determinate"} value={percentage}/> : null}
            {versionSyncInProgress ? <StopSyncButton id={id}/> : null}
          </div>
  })


// WEBPACK FOOTER //
// ./src/modules/syncIndicator/CollectionVersionSyncIndicator.tsx